export default __webpack_public_path__ + "static/media/img-35.5a81fa17.jpg";